export const comments = [
  {
    id: 1,
    stars: '/reviews/five-starts-google.svg',
    title: 'Legit!',
    text: 'Mawoo Pets is legit. They stayed in touch me. They also gives you the breeder contact information. I bought my first dog a chi weenie. The breeder Marsan Was very knowledgeable and answered any questions I had.',
    name: 'JaNae Stokes,',
    date: 'May 1',
    logoGoogle: '/reviews/google-reviews.svg',
  },
  {
    id: 2,
    stars: '/reviews/five-starts-google.svg',
    title: 'Best service ever',
    text: 'I recently bought a puppy from MawooPets. They have had the service service ever. I highly recommend this company for anyone interested in buying a puppy. You will enjoy the process working with this company and the smooth way you recieve your puppy.',
    name: 'Shahzad Saghafian,',
    date: ' November 15',
    logoGoogle: '/reviews/google-reviews.svg',
  },
  {
    id: 3,
    stars: '/reviews/five-starts-google.svg',
    title: 'Mawoo Pets is seriously awesome',
    text: "Mawoo Pets is seriously awesome, and my entire journey with them was fantastic, from start to finish. Right after I got my puppy, they sent me reassuring text messages to confirm my info was safe and sound. They were always there to answer my questions. When the driver picked up my pup from the breeder, I even got pics, updates, and location details. The whole experience was pure joy. I\n'm definitely gonna shout out Mawoo Pets to all my family and pals. You guys did a stellar job. My hubby and I are head over heels for our new furball, and she's the perfect addition to our family! Thanks a bunch, Mawoo Pets - 10/10!",
    name: 'Tanita W.',
    date: '',
    logoGoogle: '',
  },
  {
    id: 4,
    stars: '/reviews/five-starts-google.svg',
    title: 'This service truly stands out...',
    text: 'This service truly stands out as exceptional. Being a former veterinary technician, wildlife rehabber, and zookeeper, I can confidently say that Mawoo brings together pet enthusiasts in a remarkable way. The seamless delivery of our new furry family member not only met expectations but surpassed them. The unexpected VIP treatment and the caring breeder added a special touch. Amidst a recent family tragedy, the arrival of our delightful shorkie has brought a much-needed bright spot to our lives. Mawoo has earned our gratitude and respect, making them a standout company in our eyes. Thank you!',
    name: 'Zephyr B.',
    date: '',
    logoGoogle: '',
  },
  {
    id: 5,
    stars: '/reviews/five-starts-google.svg',
    title: 'They were very kind during...',
    text: "They were very kind during the process. Whenever we called or sent a message with a question, they answered fast, and we liked getting updates by text about the next steps in buying and getting our french bulldog puppy. Our puppy was brought to us by a transport service, and when she got here, she was clean and seemed happy. The driver explained how the trip went and made sure she was handed to the right people. We liked how careful he was. We've also been able to text the breeder with questions, and she's been very helpfull. 10/10 we would use mawoo pets again.",
    name: 'Amelia B.',
    date: '',
    logoGoogle: '',
  },
  {
    id: 6,
    stars: '/reviews/five-starts-google.svg',
    title: 'Mawoo Miracles truly delivers!',
    text: "Mawoo Miracles truly delivers! As a seasoned professional in animal care, I recognize excellence, and Mawoo surpasses expectations. Our new furry addition is not only as described but has brought unimaginable joy. The unexpected VIP treatment and the caring breeder add to the commendable experience. Amidst recent family tragedy, Mawoo's role in introducing our bright shorkie has been a beacon of hope, helping us embark on a new chapter. Mawoo, your impact is truly appreciated by our Austin, TX family. Gratitude!",
    name: 'Rifal D.',
    date: '',
    logoGoogle: '',
  },
  {
    id: 7,
    stars: '/reviews/five-starts-google.svg',
    title: 'I had a great time with Mawoo!',
    text: 'I had a great time with Mawoo! The customer service was very good, and Amber was really helpful, answering all my questions and being kind about my worries. My family and I are really happy with our new Yorkie puppy! I would suggest them to anyone wanting to get a new puppy. Thanks Mawoo for your great service!',
    name: 'Lanedra',
    date: '',
    logoGoogle: '',
  },
  {
    id: 8,
    stars: '/reviews/five-starts-google.svg',
    title: 'Wow, my experience with...',
    text: 'Wow, my experience with this company was fantastic! I had a bad encounter trying to buy a pet elsewhere and lost a lot of money. So, I was super cautious this time. I checked this website, hoping for a "buy now, pay later" option, and I got approved. That made me really happy. I found the pet of my dreams, and I was eager to see how it would go. I decided to pick her up myself.',
    name: 'Jennie L.',
    date: '',
    logoGoogle: '',
  },
]
